import { AutocompleteSource } from "@algolia/autocomplete-core";
import { getAlgoliaResults } from "@algolia/autocomplete-js";

import { isDefined } from "@utils/helpers";

import { AlgoliaClient } from "@services/algolia/types/client.types";

import {
    QUERY_SUGGESTIONS_COUNT,
    QUERY_SUGGESTIONS_SOURCE_ID,
} from "@components/Search/SearchAutocomplete/autoCompleteConstants";
import { QuerySuggestionsSourceType } from "@components/Search/SearchAutocomplete/autocompleteTypes";
import transformQueryForMultiSku from "@components/Search/SearchAutocomplete/helpers/multiSku.helpers";

export const querySuggestionsSource = (
    indexName: string,
    searchClient?: AlgoliaClient,
): AutocompleteSource<QuerySuggestionsSourceType> => ({
    sourceId: QUERY_SUGGESTIONS_SOURCE_ID,
    getItemInputValue({ item }) {
        return item.query;
    },
    getItems({ query }) {
        return isDefined(searchClient)
            ? getAlgoliaResults<QuerySuggestionsSourceType>({
                  searchClient: searchClient,
                  queries: [
                      {
                          indexName: indexName,
                          params: {
                              hitsPerPage: QUERY_SUGGESTIONS_COUNT,
                              query: query,
                              clickAnalytics: true,
                          },
                      },
                  ].map(transformQueryForMultiSku),
              })
            : [];
    },
});
